import React from "react";

const NextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={`${className} custom-arrow custom-arrow-next`}
      style={{ ...style, display: "block", right: 0 }}
      onClick={onClick}
    >
      &gt;
    </div>
  );
};

const PrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={`${className} custom-arrow custom-arrow-prev`}
      style={{ ...style, display: "block", left: 0 }}
      onClick={onClick}
    >
      &lt;
    </div>
  );
};

export { NextArrow, PrevArrow };
